import { NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { NgxPaginationModule, PaginatePipe } from 'ngx-pagination';
import { EncryptionService } from 'src/app/service/encryption.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { Meta } from '@angular/platform-browser';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { LetsChatComponent } from "../lets-chat/lets-chat.component";
import { Title } from '@angular/platform-browser';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-knowledge-base',
    standalone: true,
    templateUrl: './knowledge-base.component.html',
    styleUrls: ['./knowledge-base.component.less'],
    imports: [MatTabsModule, NgFor, NgIf, NgxPaginationModule, LetsChatComponent]
})


export class KnowledgeBaseComponent {
  
  faqArray = [];
  mainBaseArray = [];
  knowledgeBaseCategory = [];
  titleArrayForKeywords = [];

  baseState: any;

  p: number = 1;
  selected: number;  
  pageNumber: number = 1;
    
  categoryTitles: string;
  baseCategoryId: string;
  mainCategoryName: string;

  private routerSubscription: Subscription;

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private meta: Meta,
    private globalValueService: GlobalValueService,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private constantService: ConstantService
  ) {}


  ngOnInit(): void {

    this.route.url.subscribe(segments => {
      if (segments.length > 0) {
        this.mainCategoryName = segments[segments.length - 1].path;
      } else {
        console.error('URL segments are empty');
      }
    });

    this.backNavigation();

    this.dataService.data.subscribe((mainCategoryArray) => {
      if(mainCategoryArray.length > 0){
        mainCategoryArray.forEach((element, index) => {
          if(element.permalink == this.mainCategoryName){
            this.selected = index;
            this.baseCategoryId = element.id;
          }
        });
      }

      this.knowledgeBaseCategory = mainCategoryArray;

      for(let i=0; i<this.knowledgeBaseCategory.length; i++) {
        this.mainBaseArray[i] = this.knowledgeBaseCategory[i];
        this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + this.knowledgeBaseCategory[i].name;
        this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
        if(this.mainBaseArray[i].child.length == 0 && this.mainCategoryName === this.mainBaseArray[i].permalink){
          this.frequentlyAskedQuestions(this.mainBaseArray[i].id);
        }
      }
      var str = this.titleArrayForKeywords.join(", ");
      this.meta.updateTag({ name: this.constantService.keywords, content: str }); 
    });
    
    this.addMetaTag();
  }

  backNavigation() {
    try {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {        
            this.dataService.data.subscribe((mainCategoryArray) => {
              if(mainCategoryArray.length > 0){
                mainCategoryArray.forEach((element, index) => {
                  if(element.permalink == event.url.slice(1)){
                    this.selected = index;
                  }
                });
              }
            });
          }
        }
      });
    } catch (e) {
      console.log('Error in backNavigation method - ', e);
    }
  }

  addMetaTag(): void {
    this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
  }

  async knowledgeBase(): Promise<void> {
    try {
        for(let i=0; i<this.knowledgeBaseCategory.length; i++){
           this.mainBaseArray[i] = this.knowledgeBaseCategory[i];
           this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + this.knowledgeBaseCategory[i].name;
           this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
           this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
        }
      var str = this.titleArrayForKeywords.join(", ");
      this.meta.updateTag({ name: this.constantService.keywords, content: str });     
    } catch (e) {
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }  

  async frequentlyAskedQuestions(id): Promise<void> {
    try {
      this.faqArray = [];
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = id;
      const from = this.constantService.faqRequestConstant.faqFrom;
      const limit = this.constantService.faqRequestConstant.faqLimitMax;
      const sortBy = this.constantService.faqRequestConstant.faqSortByLike;
      const locale = this.constantService.faqRequestConstant.faqlocale;
    
      await this.forumApiService.frequentlyAskedQuestions(portalId, categoryId, from, limit, sortBy, locale).then(async (faqResponse) => {
        for(let i=0; i<faqResponse.data.length; i++){
          this.faqArray[i] = faqResponse.data[i];         
        }
      });
    } catch (e) {
      console.group('Error Occured in frequentlyAskedQuestions : ', e);
    }    
  }

  clearPagination(tabEvent): void {
    this.p = 1;
    this.pageNumber = 1;
    
    for(let i=0; i<this.mainBaseArray.length; i++){
      if(tabEvent.tab.textLabel == this.mainBaseArray[i].name){
        this.mainCategoryName = this.mainBaseArray[i].permalink;
        this.frequentlyAskedQuestions(this.mainBaseArray[i].id);
        this.baseCategoryId = this.mainBaseArray[i].id;
        this.titleService.setTitle(this.constantService.fivePaisaTextTitle + ' ' + tabEvent.tab.textLabel + ' ' + this.constantService.knowledgeBaseText);
        this.router.navigateByUrl(this.mainCategoryName);
      }      
    }
  }

  setValues(value1: string, value2: string) : void {
    try{
      this.globalValueService.mainCategory = value1;
      this.globalValueService.subCategory = value2;
    } catch (e){
      console.log('Error in setValues method - ',e);
    }    
  }

  goToSubCategory(subId: string, subCategoryName: string): void{
   try{
    if(localStorage.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
      this.setValues(this.baseCategoryId, subId);
    }
    this.router.navigateByUrl(this.mainCategoryName + '/' + subCategoryName);
   } catch(e){
    console.log('Error in goToSubCategory - ',e);
   }    
  }

  goTosubCategoryAnswers(questionId: string, subCategoryName: string, questionTitle: string): void {
    try{
      const sanitizedQuestionTitle = questionTitle.replace(/\//g, 'Or');
      this.router.navigate([this.mainCategoryName + '/' + subCategoryName + '/' + sanitizedQuestionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e);
    }
  }
}